
export const to12Hour = (hhmm) => {
    if (!hhmm) return ''
    const [h, m] = hhmm.split(':').map(Number)
    const ampm   = h >= 12 ? 'PM' : 'AM'
    const hour12 = h % 12 || 12
    return `${String(hour12).padStart(2, '0')}:${String(m).padStart(2, '0')} ${ampm}`
}

export const parseTimeRange = (timeStr) => {
    if (!timeStr) return { from: '', to: '' }
    const matches = timeStr.match(/\d{1,2}:\d{2}/g) || []
    return {
        from: matches[0] ? to12Hour(matches[0]) : '',
        to:   matches[1] ? to12Hour(matches[1]) : '',
    }
}